import Model from 'src/storage/base';
import moment from 'moment';

export class BasePaymentCardModel extends Model {
  id = 'BasePaymentCardModel';
  defaultState = () => ({
    cardExpireMonth: '01',
    cardExpireYear: moment().year(),
    cards: []
  });

  apiConfig = {
    stripeList: {
      url: 'card/stripe-list-payment-methods',
      validation: {
        limit: 'number'
      },
      cancellable: true
    },
    stripeActive: {
      url: 'card/stripe-default-payment-method',
      validation: {
        id: 'string'
      },
      cancellable: true
    },
    stripeRemove: {
      url: 'card/stripe-remove-payment-method',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onLoad = () => this.stripeList();

  setActive = (id, force) => {
    let prevActive = !force && this.activeCard;
    if (id === prevActive) return;
    this.setState({
      cards: this.state.cards.map((item) =>
        item.id !== id ? { ...item, active: false } : { ...item, active: true }
      )
    });
    this.emit('update_card_list', this.state.cards);
  };

  stripeActive = (data, force) => {
    this.log('stripeActive', data);
    if (!data) return;
    if (data.id === 'new') return;
    let { id, cb } = data;
    let prevActive = !force && this.activeCard;
    if (prevActive?.id === id) return this.log('same active, ignore');
    this.setActive(id, force);
    this.api('stripeActive', { id }, (err, data, success) => {
      cb && cb(err, data, success);
      if (!success) this.setActive(prevActive);
    });
  };

  stripeRemove = ({ id, cb }, cb2) => {
    let wasActive = this.activeCard?.id === id;
    let _cb = cb || cb2;
    this.api('stripeRemove', { id }, (err, data, success) => {
      if (success) {
        let cards = this.state.cards.filter((item) => item.id !== id) || [];
        this.setState({
          cards
        });
        if (wasActive && cards?.length > 0) this.stripeActive(cards[0]);
        this.emit('update_card_list', this.state.cards);
      }
      _cb && _cb(err, data, success);
    });
  };

  stripeList = (params) => {
    const req = {
      limit: 100
    };
    this.api('stripeList', req, (err, data, success) => {
      if (success) {
        this.setState({ cards: data });
        this.emit('update_card_list', data);
      }
      this.log('stripeList done', params?.cb);
      params?.cb && params.cb(err, data, success);
    });
  };

  get activeCard() {
    let cards = this.state.cards || [];
    let _activeCard = cards.find((item) => item.active);
    if (!_activeCard && cards.length > 0) {
      _activeCard = cards[0];
      this.stripeActive(_activeCard, true);
    }
    return _activeCard;
  }
}

const model = new BasePaymentCardModel();
export default model;
